export interface LineItem {
  description: string;
  qty: number;
  rate_paise: number;
  discount_paise: number;
  category?: "consultation" | "medication" | "procedure";
}

/** GST slabs a clinic can charge on a patient bill (same as Finance settings). */
export const GST_SLABS = [0, 5, 12, 18] as const;
export type GstSlab = (typeof GST_SLABS)[number];

export interface InvoiceCreate {
  consultation_fee_paise: number;
  medication_charges_paise: number;
  procedure_charges_paise: number;
  discount_paise: number;
  /** Omit to let the server apply the clinic's default slab. */
  gst_rate?: GstSlab;
  notes?: string;
  bill_date?: string;
  line_items?: LineItem[];
}

export interface InvoiceUpdate {
  consultation_fee_paise?: number;
  medication_charges_paise?: number;
  procedure_charges_paise?: number;
  discount_paise?: number;
  gst_rate?: GstSlab;
  notes?: string;
  bill_date?: string;
  line_items?: LineItem[];
}

export interface RecordPaymentPayload {
  method: "cash" | "upi" | "cheque" | "bank_transfer" | "other";
  payment_reference?: string;
  paid_at?: string;
  amount_collected_paise?: number;
}

export type InvoiceStatus = "draft" | "sent" | "paid" | "overdue" | "partially_paid";
export type PaymentMethod = "cash" | "upi" | "cheque" | "bank_transfer" | "other";

export interface InvoiceResponse {
  invoice_id: string;
  visit_id: string;
  patient_id: string;
  clinic_id: string;
  doctor_id: string;
  invoice_number: string;
  consultation_fee_paise: number;
  medication_charges_paise: number;
  procedure_charges_paise: number;
  discount_paise: number;
  gst_rate: number;
  gst_amount_paise: number;
  total_paise: number;
  total_display: string;
  status: InvoiceStatus;
  payment_method: PaymentMethod | null;
  payment_reference?: string | null;
  paid_at?: string | null;
  payment_recorded_at: string | null;
  notes: string | null;
  bill_date?: string | null;
  line_items?: LineItem[] | null;
  amount_collected_paise?: number | null;
  outstanding_balance_paise?: number;
  /** Cumulative Razorpay payment.failed attempts; status stays sent/overdue. */
  payment_attempt_count?: number;
  last_payment_failed_at?: string | null;
  last_payment_failure_reason?: string | null;
  clinic_name?: string | null;
  created_at: string;
  updated_at: string;
  warnings?: string[];
}

export interface InvoicePdfResponse {
  pdf_url: string;
  expires_in_seconds: number;
}
